class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector("details");
    this.content =
      this.mainDetailsToggle.querySelector("summary").nextElementSibling;

    this.mainDetailsToggle.addEventListener(
      "focusout",
      this.onFocusOut.bind(this),
    );
    this.mainDetailsToggle.addEventListener("toggle", this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    // Mega menu animation is handled entirely by CSS transitions
    if (this.mainDetailsToggle.classList.contains("mega-menu")) {
      return;
    }

    if (!this.animations) {
      this.animations = this.content.getAnimations();
    }

    if (this.mainDetailsToggle.hasAttribute("open")) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute("open");
    this.mainDetailsToggle
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
  }
}

customElements.define("details-disclosure", DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector(".header-wrapper");

    if (this.mainDetailsToggle.classList.contains("mega-menu")) {
      this.addEventListener("mouseenter", this.onMouseEnter.bind(this));
      this.addEventListener("mouseleave", this.onMouseLeave.bind(this));
    }
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (
      document.documentElement.style.getPropertyValue(
        "--header-bottom-position-desktop",
      ) !== ""
    )
      return;
    document.documentElement.style.setProperty(
      "--header-bottom-position-desktop",
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`,
    );
  }

  onMouseEnter() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches) {
      return;
    }

    clearTimeout(this.hoverTimeout);

    // Close all other mega menus immediately
    document.querySelectorAll("header-menu").forEach((menu) => {
      if (
        menu !== this &&
        menu.mainDetailsToggle?.classList.contains("mega-menu") &&
        menu.mainDetailsToggle.open
      ) {
        menu.close();
      }
    });

    const details = this.mainDetailsToggle;
    const summary = details.querySelector("summary");
    const content = this.content;

    if (details.open) return;

    // Reset animation state
    details.classList.remove("is-opening");

    details.open = true;
    summary?.setAttribute("aria-expanded", "true");

    // Force initial hidden state to render
    content.getBoundingClientRect();

    requestAnimationFrame(() => {
      details.classList.add("is-opening");
    });
  }

  onMouseLeave() {
    if (!window.matchMedia("(hover: hover) and (pointer: fine)").matches)
      return;
    clearTimeout(this.hoverTimeout);
    this.hoverTimeout = setTimeout(() => this.close(), 150);
  }

  close() {
    clearTimeout(this.hoverTimeout);

    this.mainDetailsToggle.classList.remove("is-opening");

    super.close();
  }
}

customElements.define("header-menu", HeaderMenu);

// Mobile menu promotional banners slider
document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".menu-drawer__banner-slider").forEach((slider) => {
    const track = slider.querySelector(".menu-drawer__banner-slider-list");
    const prev = slider.querySelector(".menu-drawer__banner-arrow--prev");
    const next = slider.querySelector(".menu-drawer__banner-arrow--next");

    if (!track || !prev || !next) return;

    const getScrollAmount = () => {
      const slide = track.querySelector(".menu-drawer__banner-slide");

      if (!slide) return 0;

      const styles = getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 0;

      return slide.getBoundingClientRect().width + gap;
    };

    const scrollSlider = (direction) => {
      track.scrollBy({
        left: getScrollAmount() * direction,
        behavior: "smooth",
      });
    };

    const handleArrow = (event, direction) => {
      event.preventDefault();
      event.stopPropagation();

      scrollSlider(direction);
    };

    prev.addEventListener("click", (event) => {
      handleArrow(event, -1);
    });

    next.addEventListener("click", (event) => {
      handleArrow(event, 1);
    });

    // Keyboard accessibility for the span buttons
    [prev, next].forEach((arrow, index) => {
      arrow.addEventListener("keydown", (event) => {
        if (event.key !== "Enter" && event.key !== " ") return;

        event.preventDefault();
        event.stopPropagation();

        scrollSlider(index === 0 ? -1 : 1);
      });
    });

    const updateArrows = () => {
      const maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);

      const atStart = track.scrollLeft <= 2;
      const atEnd = track.scrollLeft >= maxScroll - 2;

      prev.classList.toggle("is-disabled", atStart);
      next.classList.toggle("is-disabled", atEnd);

      prev.setAttribute("aria-disabled", String(atStart));
      next.setAttribute("aria-disabled", String(atEnd));
    };

    track.addEventListener("scroll", updateArrows, {
      passive: true,
    });

    updateArrows();
  });

  /*
   * Every time a mobile submenu is opened,
   * reset its promotional slider to the beginning.
   */
  document.querySelectorAll(".menu-drawer__submenu").forEach((submenu) => {
    const details = submenu.closest("details");

    if (!details) return;

    details.addEventListener("toggle", () => {
      if (!details.open) return;

      const track = submenu.querySelector(".menu-drawer__banner-slider-list");

      if (!track) return;

      requestAnimationFrame(() => {
        track.scrollTo({
          left: 0,
          behavior: "instant",
        });
      });
    });
  });
});
